import type {
  GlobalFilterSearchQuery,
  GlobalFilterSearchQueryVariables,
} from 'src/types';
import globalFiltersSearchQuery from '../search-global-filters.graphql';
import { useGqlQuery } from 'src/hooks/use-gql-query';

export function useGlobalFilterSearchQuery(
  variables: GlobalFilterSearchQueryVariables
) {
  return useGqlQuery<GlobalFilterSearchQuery>({
    query: globalFiltersSearchQuery,
    queryKey: ['productCollectionGlobalFilters'],
    variables,
    enabled: !!variables.definitionId,
  });
}
